<ndt-account-role-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [rolePrivileges]="rolePrivileges$ | async"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-account-role-register-view>
